enum LicensesEnum {
  CHRONA = 'CHRONA',
  SURA = 'SURA',
  UMI = 'UMI',
  JORO = 'JORO',
}

export default LicensesEnum;
